import { render, staticRenderFns } from "./comLogin.vue?vue&type=template&id=12c53f4f&scoped=true"
import script from "./comLogin.vue?vue&type=script&lang=js"
export * from "./comLogin.vue?vue&type=script&lang=js"
import style0 from "./comLogin.vue?vue&type=style&index=0&id=12c53f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c53f4f",
  null
  
)

export default component.exports